<template>
    <div :class="'wrapper sidebar-mini ' + sidebar">
        <template v-if="configuracion">
            <LoadCssComponent :estilos="configuracion.css_back"></LoadCssComponent>
        </template>

        <HeaderComponent v-on:collapse="collapse"></HeaderComponent>

        <AsideComponent :sidebar="sidebar"></AsideComponent>

        <div class="content-wrapper" @click="restore">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>

        <FooterComponent></FooterComponent>
    </div>
</template>

<script>
import FooterComponent from '@/components/backend/footer/FooterComponent';
import HeaderComponent from '@/components/backend/header/HeaderComponent';
import AsideComponent from '@/components/backend/aside/AsideComponent';
import LoadCssComponent from  '@/components/css/LoadCssComponent';

export default {
    data() {
        return {
            sidebar: ''
        }
    },
    head: {
        link: function() {
            return [
                { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/fontawesome-free/css/all.min.css') },
                { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css') },
                { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/icheck-bootstrap/icheck-bootstrap.min.css') },
                { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/jqvmap/jqvmap.min.css') },
                { rel: 'stylesheet', href: require('@/assets/adminlte/css/adminlte.min.css') },
                { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css') },
                { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/daterangepicker/daterangepicker.css') },
                { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/summernote/summernote-bs4.css') }
            ]
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        collapse() {
            if(this.sidebar == '') {
                this.sidebar = 'sidebar-collapse sidebar-open';
            } else {
                this.sidebar = '';
            }
        },
        restore() {
            this.sidebar = '';
        }
    },
    components: {
        FooterComponent, HeaderComponent, AsideComponent, LoadCssComponent
    }
}
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
